import React, { useState, useEffect } from 'react';
import { Activity, CheckCircle, XCircle, Wifi, Database, Brain, Zap } from 'lucide-react';
import { useI18n } from '../i18n';
import { health } from '../services/api/client';

const ServicesStatus = () => {
  const { t } = useI18n();

  const [services, setServices] = useState({
    backend: { status: 'checking', nameKey: 'dashboard.services.backendApi' },
    frontend: { status: 'online', nameKey: 'dashboard.services.frontend' },
    database: { status: 'checking', nameKey: 'dashboard.services.postgresql' },
    ai: { status: 'checking', nameKey: 'dashboard.services.aiModels' }
  });

  useEffect(() => {
    checkServices();
    const interval = setInterval(checkServices, 30000); // Check every 30s
    return () => clearInterval(interval);
  }, []);

  const checkServices = async () => {
    // Backend check using apiClient for consistent error handling
    try {
      const healthData = await health.check();
      const isHealthy = healthData?.status === 'healthy' || healthData?.status === 'degraded';
      setServices(prev => ({
        ...prev,
        backend: { ...prev.backend, status: isHealthy ? 'online' : 'offline' },
        database: { ...prev.database, status: healthData?.checks?.database === 'healthy' ? 'online' : 'offline' }
      }));
    } catch {
      // Silently handle errors - service status shown as offline
      setServices(prev => ({
        ...prev,
        backend: { ...prev.backend, status: 'offline' }
      }));
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'online': return 'text-green-500';
      case 'offline': return 'text-red-500';
      case 'degraded': return 'text-yellow-500';
      default: return 'text-gray-500';
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'online': return <CheckCircle className="w-3 h-3" />;
      case 'offline': return <XCircle className="w-3 h-3" />;
      default: return <Activity className="w-3 h-3 animate-pulse" />;
    }
  };

  return (
    <div className="flex items-center gap-4 text-xs flex-wrap">
      {Object.entries(services).map(([key, service]) => (
        <div key={key} className="flex items-center gap-1.5 min-w-0">
          <span className={`${getStatusColor(service.status)} flex-shrink-0`}>
            {getStatusIcon(service.status)}
          </span>
          <span className="text-gray-400 truncate max-w-[100px]" title={t(service.nameKey)}>{t(service.nameKey)}</span>
        </div>
      ))}
    </div>
  );
};

export default ServicesStatus;
